import KyThi from "./KyThi";

export default KyThi